import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-container order-content" }
const _hoisted_2 = { class: "price" }
const _hoisted_3 = { class: "pay-methods" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_cta_button = _resolveComponent("cta-button")!
  const _component_base_panel = _resolveComponent("base-panel")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "page-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ionic-header ion-no-border",
        mode: "ios",
        "no-border": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            class: "toolbar",
            mode: "ios",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    icon: _ctx.BackIcon,
                    "default-href": "/",
                    text: ""
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
                          fill: "black"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "title" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Betaalmethode ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-content-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            _createVNode(_component_base_panel, null, {
              content: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "heading" }, " Kies een betaalmethode ", -1)),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.totalPrice), 1),
                _createVNode(_component_cta_button, {
                  class: "orange-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toOnlineBanking('iD')))
                }, {
                  content: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("svg", {
                      class: "icon",
                      fill: "none",
                      viewBox: "0 0 28 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("g", { "clip-path": "url(#clip0_145_556)" }, [
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M1.4217 0.951352C6.12278 0.952883 9.64859 0.954035 11.9991 0.954807C13.6151 0.955339 13.6151 0.955339 14.6435 0.955681C15.378 0.955928 15.378 0.955928 15.5337 0.956057C18.6302 1.00612 21.2636 1.89548 23.1539 3.54857C24.2347 4.49376 25.0685 5.68022 25.6306 7.07047C26.2126 8.51009 26.5058 10.1784 26.5058 12.0283C26.5058 15.9079 25.3777 18.8488 23.1333 20.7278C21.2968 22.2652 18.7362 23.058 15.5248 23.1052H0.867676V0.951172L1.4217 0.951352Z",
                          fill: "#D98240",
                          "fill-rule": "evenodd",
                          stroke: "#D98240",
                          "stroke-width": "1.8"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M4.23682 19.6445H8.11578V13.3066H4.23682V19.6445Z",
                          fill: "white",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M8.409 10.1372C8.409 11.3303 7.42587 12.2982 6.21329 12.2982C5.00075 12.2982 4.01758 11.3303 4.01758 10.1372C4.01758 8.94397 5.00075 7.97656 6.21329 7.97656C7.42587 7.97656 8.409 8.94397 8.409 10.1372Z",
                          fill: "white",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M15.1996 2.99557C17.8968 2.99557 20.1447 3.71465 21.7004 5.0751C23.459 6.61296 24.3507 8.94294 24.3507 12.0004C24.3507 18.0596 21.3573 21.0051 15.1996 21.0051C14.721 21.0051 4.17828 21.0051 2.94768 21.0051C2.94768 19.7695 2.94768 4.2312 2.94768 2.99557C4.17828 2.99557 14.721 2.99557 15.1996 2.99557ZM15.4629 1.61621H1.5459V22.3845H15.4629V22.3806C18.5029 22.3398 20.9112 21.5967 22.6202 20.1659C24.6986 18.4259 25.7525 15.6786 25.7525 12.0004C25.7525 10.2421 25.4753 8.66498 24.9286 7.31285C24.4057 6.01937 23.6328 4.91958 22.6316 4.044C20.8682 2.50196 18.393 1.66815 15.4629 1.62078C15.4629 1.62074 15.4629 1.61621 15.4629 1.61621Z",
                          fill: "#0A0B09",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M15.1996 2.99557C17.8968 2.99557 20.1447 3.71465 21.7004 5.0751C23.459 6.61296 24.3507 8.94294 24.3507 12.0004C24.3507 18.0596 21.3573 21.0051 15.1996 21.0051C14.721 21.0051 4.17828 21.0051 2.94768 21.0051C2.94768 19.7695 2.94768 4.2312 2.94768 2.99557C4.17828 2.99557 14.721 2.99557 15.1996 2.99557ZM15.4629 1.61621H1.5459V22.3845H15.4629V22.3806C18.5029 22.3398 20.9112 21.5967 22.6202 20.1659C24.6986 18.4259 25.7525 15.6786 25.7525 12.0004C25.7525 10.2421 25.4753 8.66498 24.9286 7.31285C24.4057 6.01937 23.6328 4.91958 22.6316 4.044C20.8682 2.50196 18.393 1.66815 15.4629 1.62078C15.4629 1.62074 15.4629 1.61621 15.4629 1.61621Z",
                          fill: "white",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M14.8172 19.6512H9.89697V4.6748H14.8172H14.6186C18.7219 4.6748 23.0896 6.26828 23.0896 12.1827C23.0896 18.4352 18.7219 19.6512 14.6186 19.6512H14.8172Z",
                          fill: "white",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M9.78725 9.15188V11.5337H10.3405C10.5474 11.5337 10.6967 11.5223 10.7885 11.4994C10.9087 11.47 11.0084 11.4201 11.0877 11.3497C11.1669 11.2794 11.2316 11.1637 11.2817 11.0027C11.3317 10.8416 11.3568 10.622 11.3568 10.344C11.3568 10.066 11.3317 9.85263 11.2817 9.70378C11.2316 9.555 11.1615 9.4389 11.0714 9.35551C10.9813 9.27208 10.8669 9.21568 10.7284 9.1862C10.6249 9.16334 10.4222 9.15188 10.1202 9.15188H9.78725ZM9.04883 8.54102H10.3997C10.7044 8.54102 10.9366 8.56395 11.0964 8.60983C11.3111 8.67209 11.4951 8.78272 11.6482 8.9417C11.8014 9.10064 11.9179 9.29525 11.9979 9.52548C12.0778 9.75572 12.1177 10.0396 12.1177 10.3772C12.1177 10.6738 12.0802 10.9294 12.0053 11.1441C11.9138 11.4063 11.7831 11.6185 11.6133 11.7808C11.4851 11.9037 11.312 11.9995 11.0939 12.0684C10.9307 12.1192 10.7127 12.1446 10.4397 12.1446H9.04883V8.54102Z",
                          fill: "#D98240",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M12.9531 12.1446V8.54102H15.6641V9.15188H13.6916V9.94993H15.5264V10.5608H13.6916V11.5337H15.7342V12.1446H12.9531Z",
                          fill: "#D98240",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M18.5082 10.716L18.0034 9.38093L17.5087 10.716H18.5082ZM19.8695 12.1446H19.0651L18.7455 11.3268H17.2824L16.9793 12.1446H16.1948L17.618 8.54102H18.405L19.8695 12.1446Z",
                          fill: "#D98240",
                          "fill-rule": "evenodd"
                        }),
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M20.4873 12.1443V8.57031H21.2258V11.5335H23.0656V12.1443H20.4873Z",
                          fill: "#D98240",
                          "fill-rule": "evenodd"
                        })
                      ]),
                      _createElementVNode("defs", null, [
                        _createElementVNode("clipPath", { id: "clip0_145_556" }, [
                          _createElementVNode("rect", {
                            fill: "white",
                            height: "24",
                            width: "27.2308"
                          })
                        ])
                      ])
                    ], -1),
                    _createElementVNode("span", { class: "title" }, "Online bankieren", -1)
                  ]))]),
                  icon: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      class: "icon arrow",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("g", { opacity: "0.4" }, [
                        _createElementVNode("path", {
                          d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                          fill: "white"
                        })
                      ])
                    ], -1)
                  ]))]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "or-divider" }, [
                  _createElementVNode("div", { class: "bar-left" }),
                  _createElementVNode("p", null, "Of"),
                  _createElementVNode("div", { class: "bar-right" })
                ], -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_cta_button, { onClick: _ctx.toPinDevice }, {
                    content: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M17 2H7C5.9 2 5 2.9 5 4V6C5 7.1 5.9 8 7 8H17C18.1 8 19 7.1 19 6V4C19 2.9 18.1 2 17 2ZM17 6H7V4H17V6ZM20 22H4C2.9 22 2 21.1 2 20V19H22V20C22 21.1 21.1 22 20 22ZM18.53 10.19C18.21 9.47 17.49 9 16.7 9H7.3C6.51 9 5.79 9.47 5.47 10.19L2 18H22L18.53 10.19ZM9.5 16H8.5C8.22 16 8 15.78 8 15.5C8 15.22 8.22 15 8.5 15H9.5C9.78 15 10 15.22 10 15.5C10 15.78 9.78 16 9.5 16ZM9.5 14H8.5C8.22 14 8 13.78 8 13.5C8 13.22 8.22 13 8.5 13H9.5C9.78 13 10 13.22 10 13.5C10 13.78 9.78 14 9.5 14ZM9.5 12H8.5C8.22 12 8 11.78 8 11.5C8 11.22 8.22 11 8.5 11H9.5C9.78 11 10 11.22 10 11.5C10 11.78 9.78 12 9.5 12ZM12.5 16H11.5C11.22 16 11 15.78 11 15.5C11 15.22 11.22 15 11.5 15H12.5C12.78 15 13 15.22 13 15.5C13 15.78 12.78 16 12.5 16ZM12.5 14H11.5C11.22 14 11 13.78 11 13.5C11 13.22 11.22 13 11.5 13H12.5C12.78 13 13 13.22 13 13.5C13 13.78 12.78 14 12.5 14ZM12.5 12H11.5C11.22 12 11 11.78 11 11.5C11 11.22 11.22 11 11.5 11H12.5C12.78 11 13 11.22 13 11.5C13 11.78 12.78 12 12.5 12ZM15.5 16H14.5C14.22 16 14 15.78 14 15.5C14 15.22 14.22 15 14.5 15H15.5C15.78 15 16 15.22 16 15.5C16 15.78 15.78 16 15.5 16ZM15.5 14H14.5C14.22 14 14 13.78 14 13.5C14 13.22 14.22 13 14.5 13H15.5C15.78 13 16 13.22 16 13.5C16 13.78 15.78 14 15.5 14ZM15.5 12H14.5C14.22 12 14 11.78 14 11.5C14 11.22 14.22 11 14.5 11H15.5C15.78 11 16 11.22 16 11.5C16 11.78 15.78 12 15.5 12Z",
                          fill: "black"
                        })
                      ], -1),
                      _createElementVNode("span", { class: "title" }, "Pinautomaat", -1)
                    ]))]),
                    icon: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("svg", {
                        class: "icon arrow",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", { opacity: "0.4" }, [
                          _createElementVNode("path", {
                            d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                            fill: "black"
                          })
                        ])
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_cta_button, { onClick: _ctx.toPayLater }, {
                    content: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M20.9998 10.12H14.2198L16.9598 7.3C14.2298 4.6 9.80976 4.5 7.07976 7.2C4.34976 9.91 4.34976 14.28 7.07976 16.99C9.80976 19.7 14.2298 19.7 16.9598 16.99C18.3198 15.65 18.9998 14.08 18.9998 12.1H20.9998C20.9998 14.08 20.1198 16.65 18.3598 18.39C14.8498 21.87 9.14976 21.87 5.63976 18.39C2.13976 14.92 2.10976 9.28 5.61976 5.81C9.12976 2.34 14.7598 2.34 18.2698 5.81L20.9998 3V10.12ZM12.4998 8V12.25L15.9998 14.33L15.2798 15.54L10.9998 13V8H12.4998Z",
                          fill: "black"
                        })
                      ], -1),
                      _createElementVNode("span", { class: "title" }, "Later betalen", -1)
                    ]))]),
                    icon: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        class: "icon arrow",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", { opacity: "0.4" }, [
                          _createElementVNode("path", {
                            d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                            fill: "black"
                          })
                        ])
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}